// extracted by mini-css-extract-plugin
export default {"MainSlider":"MainSlider_MainSlider__YQKgK"};